import Hades from '@adoratorio/hades';
import engine from '@/scripts/engine';
import { isTouchDevice } from '@/scripts/utils';

const hades = {
  ref: null,

  init(DOMElement, DOMContainer) {
    hades.ref = new Hades({
      viewport: DOMElement,
      mode: /Edge/.test(navigator.userAgent) ? Hades.MODE.NATIVE : Hades.MODE.VIRTUAL,
      container: DOMContainer,
      easing: {
        mode: !isTouchDevice() ? Hades.EASING.QUAD : Hades.EASING.CUBIC,
        duration: !isTouchDevice() ? 800 : 200,
      },
      aion: engine,
      smoothDirectionChange: true,
      scrollbar: null,
      // lockY: true,
    });
  },

  setBoundries(DOMElement, offset = 0) {
    hades.ref.boundries = Hades.createBoundries(
      0,
      0,
      0,
      (DOMElement.getBoundingClientRect().height - window.innerHeight) + offset,
    );
  },
};

export default hades;
